import React, { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Alert } from "react-bootstrap";
import { authenticateOrganization } from "../service/api";
import "./OrganizationPage.css"
import HomeHeader from "./HomeHeader";
import Footer from "./Footer";
import { Checkbox } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Pincode from "./Pincode.js";
import { FadeLoader } from "react-spinners";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { LoginContext } from "../Contexts/ContextProvider";
import { useContext } from "react";


const GSTDict = {
  "35": "Andaman and Nicobar Islands",
  "28": "Andhra Pradesh",
  "37": "Andhra Pradesh",
  "12": "Arunachal Pradesh",
  "18": "Assam",
  "10": "Bihar",
  '04': "Chandigarh",
  "22": " Chattisgarh",
  "26": "Dadra and Nagar Haveli",
  "25": "Daman and Diu",
  "07": "Delhi",
  "30": "Goa",
  "24": "Gujarat",
  "06": "Haryana",
  "02": "Himachal Pradesh",
  "01": "Jammu and Kashmir",
  "20": "Jharkhand",
  "29": "Karnataka",
  "32": "Kerala",
  "31": "Lakshadweep Islands",
  "23": "Madhya Pradesh",
  "27": "Maharashtra",
  "14": "Manipur",
  "17": "Meghalaya",
  "15": "Mizoram",
  "13": "Nagaland",
  "21": "Odisha",
  "34": "Pondicherry",
  "03": "Punjab",
  "08": "Rajasthan",
  "11": "Sikkim",
  "33": "Tamil Nadu",
  "36": "Telangana",
  "16": "Tripura",
  "09": "Uttar Pradesh",
  "05": "Uttarakhand",
  "19": "West Bengal",
}
const codes = Object.keys(GSTDict);

export default function OrganizationPage() {
  const companyRef = useRef();
  const compTypeRef = useRef();
  const phonenumberRef = useRef();
  const whatsappnumberRef = useRef();
  const addressRef = useRef();
  const GSTRef = useRef();
  const personRef = useRef();
  const [error, setError] = useState("");
  const [stateValue, setStatevalue] = useState("");
  const history = useHistory();
  const [invalidGst, setInvalidGst] = useState(true);
  const [Gst, setGst] = useState("");
  const [dispWhatsapp, setdispWhatsapp] = useState('block');
  const [isChecked, setIsChecked] = useState(true);
  const [pincodeData, setPincodeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [others, setOthers] = useState('none');
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [msg, setMsg] = useState("");
  const { userid, userEmail } = useContext(LoginContext)
  const [gstindata, setGstindata] = useState([{
    GstIN: ""
  }])
  const [addressdata, setAddressdata] = useState([{
    Address: ""
  }])

  const [trucks, setTrucks] = useState([{
    number: "",
    type: ""
  }])


  async function handleSubmit(e) {
    e.preventDefault();
    //console.log(companyRef.current.value+" "+phonenumberRef+" "+addressRef);
    console.log(pincodeData);
    console.log(stateValue);
    console.log(invalidGst);
    setOpenSnackBar(true);
    setSeverity("error");
    if (invalidGst) {
      setMsg("Please provide valid Gst");
    }
    // if(addressdata.length !== pincodeData.length){
    //   setMsg("Please fill in correct PIN");
    // }
    else {
      setLoading(true);
      setOthers('block');
      setOpenSnackBar(true);
      setSeverity("success");
      setMsg("Saved Successfully");
      if (whatsappnumberRef.current.value == "") {
        await authenticateOrganization({
          Email: userEmail,
          Company: companyRef.current.value,
          CompanyType: compTypeRef.current.value,
          PIN: pincodeData,
          GSTINArr: gstindata,
          Address: addressdata,
          Person: personRef.current.value,
          Whatsapp: "NA",
          INState: stateValue,

        })
          .then(() => {
            history.push("/landing");
          })
          .catch((error) => {
            setLoading(false);
            setOthers('none');
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg(error.message);
          });
      }
      else {
        await authenticateOrganization({
          Email: userEmail,
          Company: companyRef.current.value,
          CompanyType: compTypeRef.current.value,
          PIN: pincodeData,
          GSTINArr: gstindata,
          Address: addressdata,
          Person: personRef.current.value,
          Whatsapp: whatsappnumberRef.current.value,
          INState: stateValue,
        })
          .then(() => {
            history.push("/landing");
          })
          .catch((error) => {
            setLoading(false);
            setOthers('none');
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg(error.message);

          });
      }
    }//else
  }


  function validateCode(e) {
    const Gst = e.target.value;
    if (Gst.length == 15 && Gst.charAt(13) == "Z") {
      //check state
      var state = Gst.substring(0, 2);
      if (state in GSTDict) {
        setStatevalue([...stateValue, GSTDict[state]]);
        console.log(" valid Gst");
        setInvalidGst(false);
      }
      else {
        console.log("invalid state");
      }

      //valid length and checksum
    }
    else {
      //invalid length or Z missing
      console.log("invalid length");
    }
  }

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackBar(false);
  };

  function handleCheck() {
    setIsChecked(!isChecked);
    if (isChecked) {
      setdispWhatsapp("block");
    }
    else {
      setdispWhatsapp("none");
    }
  }

  const handleFormChangegst = (index, event) => {
    console.log(event.target.name);
    console.log(event.target.value);
    let data = [...gstindata];
    data[index][event.target.name] = event.target.value;
    setGstindata(data);
  }

  const handleFormChangeadd = (index, event) => {
    console.log(event.target.name);
    console.log(event.target.value);
    let data = [...addressdata];
    data[index][event.target.name] = event.target.value;
    setAddressdata(data);
  }
  const minusInput = (index) => {
    const arr1 = [...gstindata];
    arr1.splice(index, 1);
    setGstindata(arr1);
    const arr2 = [...pincodeData];
    arr2.splice(index, 1);
    setPincodeData(arr2);
    const arr3 = [...addressdata];
    arr3.splice(index, 1);
    setAddressdata(arr3);
    const arr4 = [...stateValue];
    arr4.splice(index, 1);
    setStatevalue(arr4);
  }
  function checkGstTable() {
    if (gstindata.length <= 1) {
      return { display: 'none' };
    }
    else {
      return { display: 'block' }
    }
  }


  const addInput = () => {
    let newfieldgst = { GstIN: "" }
    let newfieldadd = { Address: "" }
    setGstindata([...gstindata, newfieldgst])
    setAddressdata([...addressdata, newfieldadd])
  }

  const scrollToFunc = () => {
    document.getElementById("TheScrollPart").scrollTop = document.getElementById("TheScrollPart").scrollHeight;
  }

  return (
    <div>
      {console.log(userid, userEmail, "PROPS")}
      <div className="LoadingScreen" style={{ display: others }}>
        <div className="loader">
          <FadeLoader color={"#B8B8B8"} loading={loading} size={150} />
        </div>
      </div>
      <Helmet>
        <title>Transit Pro | Setup your Account</title>
      </Helmet>
      <HomeHeader />
      <div className="org-container">
        <h1>Organization Details</h1>
        <form onSubmit={handleSubmit} className="org-form">
          {error && setOpenSnackBar(true) && setSeverity("error") && setMsg(error)}
          <div className="userMail">
            <strong>Logged in as:</strong> {userEmail}
          </div>
          <div className="CompanyStuff">
            <div className="textCompany">
              <label id="companyNameLabel">
                Company Name
              </label>
              <input
                className="inputCompany"
                type="text"
                id="company"
                ref={companyRef}
                required
              />

            </div>
            <div className="textType">
              <label id="companyNameLabel">
                Company Type<span style={{ color: "red" }}>*</span>
              </label>
              <select
                className="inputCompany"
                required
                ref={compTypeRef}>
                <option value="">Choose..</option>
                <option value="Partnership">Partnership</option>
                <option value="Sole Proprietorship">Sole Proprietorship</option>
                <option value="Limited Liability Partnership">Limited Liability Partnership</option>
                <option value="Private Limited Companies">Private Limited Companies</option>
                <option value="Public Limited Companies">Public Limited Companies</option>
                <option value="One-Person Companies">One-Person Companies</option>
              </select>
            </div>
          </div>
          <div className="GSTINdata">
            {gstindata.map((input, index) => {
              return (
                <div key={index}>
                  <div className="GSTINPIN">
                    <div>
                      <label id="companyNameLabel">GSTIn<span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                        name="GstIN"
                        className="inputCompany"
                        value={input.GstIN}
                        onChange={e => {
                          handleFormChangegst(index, e); {
                            if (e.target.value.length != 15 || e.target.value.charAt(13) != "Z") {
                              setInvalidGst(true);
                              console.log(invalidGst);
                            }
                          }; validateCode(e)
                        }}
                        id="GSTIN"
                        placeholder="GstIN"
                        required
                      />
                    </div>
                    <div className="plusminus">
                      <div className="addFieldEdit" style={checkGstTable()} onClick={() => minusInput()}><strong >-</strong></div>
                      <div className="addFieldEdit" onClick={() => addInput()}><strong>+</strong></div>
                    </div>
                    {/* <div>
            <label id="companyNameLabel">Pincode<span style={{color:"red"}}>*</span></label>
          <Pincode invalidError="Please check pincode" lenghtError="Pincode should be atleast 6 digits" 
          getData={(data) =>setPincodeData([...pincodeData,data])} present={false} showDistrict={false} showState={false}
          showArea={false} showCity={false} stateInput={{color:'#d3d3d3',borderBottom:'double'}} districtInput={{color:'#d3d3d3',borderBottom:'double'}}/>
          </div> */}
                  </div>
                  {/* <div className="addressField">
          <label id="companyNameLabel">Address<span style={{color:"red"}}>*</span></label>
          <input
            type="text"
            id="address"
            name="Address"
            className="inputCompany"
            placeholder="Address"
            value={input.Address}
            onChange={event=>{handleFormChangeadd(index,event)}}
            required
          />
            </div> */}
                </div>
              )
            })}

          </div>

          <label id="companyNameLabel" style={{ fontWeight: 'bold', textAlign: 'center', textAlign: 'left', marginLeft: '20px', fontSize: '16px' }}>
            Primary Contact Details
          </label>
          <div className="textGSTIN">
            <div className="textFieldPerson">
              <label id="companyNameLabel" >
                Contact Name
              </label>
              <input
                type="text"
                id="person"
                className="inputCompany"
                ref={personRef}
                required
              />
            </div>
            {/* <div id="check">
          <label id="checkbox">Whatsapp on Primary Number</label>
          <input type="checkbox"
          id="checkboxinput"
          checked={isChecked}
          onChange={()=>{handleCheck();scrollToFunc()}}
          />          
        </div> */}
            <div className="WhatsappNum" style={{ display: dispWhatsapp }}>
              <label id="companyNameLabel" >
                Whatsapp Number
              </label>
              <input
                type="number"
                id="whatsappnumber"
                className="inputCompany"
                ref={whatsappnumberRef}
              />
            </div>
          </div>
          <div className="center">
            <button
              type="submit"
              id="sub-button"
            >
              Submit
            </button>
          </div>
        </form>

      </div>
      <Footer />
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={openSnackBar}
        autoHideDuration={8000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={severity}>
          {msg}
        </Alert>
      </Snackbar>
    </div>
  );
}
